import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MattersCombobox from "../Postings/MattersComboBox.jsx";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Checkbox } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { HandleGridBody } from "components/common/HandleGridBody.js";
import {
  AmountFormat,
  AmountFormatCell,
  DateFormatCell,
  formatDateForAPI,
  AmountFormatCellEmptyZeroNoPadding
} from "components/common/formatter.js";
import { Button } from "@progress/kendo-react-buttons";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import PageTabItemTitle from "components/tabs/TabItem/PageTabItemTitle";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton.jsx";
import styles from "./BillRequests.module.scss";
import SubmitButton from "components/common/SubmitButton";

import * as api from "../../api/index.js";
import {
  authorizeBills,
  getBillingRequestDetails,
  rejectBillingReqeust,
} from "services/billingRequestsService";
import { isNonEmptyBillResourceId } from "pages/Bills/billReportResourceId";
import { AiOutlineFile } from "react-icons/ai";
import { Tooltip } from "@progress/kendo-react-tooltip";

import DocumentViewer from "components/common/DocumentViewer";
import { GRID_PAGE_SIZES } from "components/common/GridComponents";
import BillPostingModal from "pages/Bills/BillRequestModal.jsx";
import BillRequestRejectDialog from "pages/Bills/BillRequestRejectDialog.jsx";
import { useCompany } from "services/companyService.js";
import { arrowRotateCwIcon } from "@progress/kendo-svg-icons";
import { changeLedgerLink } from "actions/ledgerLinks.action";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { BILL_STATUS_TABS } from "./billRequestConstants.js";


const BillRequests = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const date = new Date();
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date()?.toISOString().split("T")[0]);
  const [showBillingRequest, setShowBillingRequest] = useState(false);
  const [billingRequestPayload, setBillingRequestPayload] = useState(false);
  const [fileData, setFileData] = useState([]);
  const [showDoc, setShowDoc] = useState(false);

  const [matterref, setmatterref] = useState(null);
  const [selectedMatter, setSelectedMatter] = useState(null);
  const [list, setLists] = useState({
    data: [],
    total: 20,
  });
  const [valueFrom, setValueFrom] = useState(false);
  const [valueTo, setValueTo] = useState(false);
  const [dataState, setDataState] = useState({
    take: 200,
    skip: 0,
    sort: [
      {
        field: "matterRef",
        dir: "asc",
      },
    ],
  });
  const [fromDateSelector, setFromDateSelector] = useState(date);
  const [toDateSelector, setToDateSelector] = useState(date);
  const { data: company } = useCompany();

  const [authChecked, setAuthChecked] = useState([]);
  const [authSelectAll, setAuthSelectAll] = useState(false);
  const [isAuthorizing, setIsAuthorizing] = useState(false);

  const [showRejectReasonDialog, setShowRejectReasonDialog] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [rejectBillId, setRejectBillId] = useState(null);
  const [isRejecting, setIsRejecting] = useState(false);

  const isLoadingBillingRequests = useSelector(
    (state) => state.billingRequests.isLoading,
  );

  const isPendingTab = activeTabIndex === 0;
  const isAuthorisationTab = activeTabIndex === 1;
  const isRejectedTab = activeTabIndex === 2;
  const isPostedTab = activeTabIndex === 3;

  const clearSelection = () => {
    setAuthChecked([]);
    setAuthSelectAll(false);
  };

  useEffect(() => {
    clearSelection();
  }, [activeTabIndex]);

  const onTabSelect = (e) => {
    setLists({ data: [], total: 0 });
    setActiveTabIndex(e.selected);
  };

  const getBillRequestDetails = async (bill) => {
    try {
      const response = await getBillingRequestDetails(bill.billRequestId);
      const detailData = response.data.data || {};
      const templateFromDetail = detailData.billTemplateResourceId;
      const merged = {
        ...bill,
        ...detailData,
        matterRef: detailData.matterRef || bill.matterRef || "",
      };
      if (isNonEmptyBillResourceId(templateFromDetail)) {
        merged.billTemplateResourceId = templateFromDetail;
      }
      setShowBillingRequest(true);
      setBillingRequestPayload(merged);
    } catch (error) { }
  };

  const onChangeFromDateSelect = (event) => {
    setFromDateSelector(event.value);
    let nextFrom = null;
    let d = new Date(event.value);
    if (event.value) {
      nextFrom = formatDateForAPI(d);
    }
    setFromDate(nextFrom);
    setValueFrom(true);
  };

  const onChangeToDateSelect = (event) => {
    setToDateSelector(event.value);
    let nextTo = null;
    let d = new Date(event.value);
    if (event.value) {
      nextTo = formatDateForAPI(d);
    }
    setToDate(nextTo);
    setValueTo(true);
  };

  useEffect(() => {
    if (company.yearStartDate !== undefined) {
      let yearsToStartDate = new Date(company.yearStartDate);
      setFromDateSelector(yearsToStartDate);
      setFromDate(formatDateForAPI(yearsToStartDate));
    }
  }, [company.yearStartDate]);

  const createState = (skip, take) => {
    let pagerSettings = {
      pageSizes: GRID_PAGE_SIZES,
    };
    return {
      pageSize: take,
      pageable: pagerSettings,
    };
  };
  const [state] = useState(createState(0, 10));

  const onChangematter = (event) => {
    const next = event?.target?.value ?? null;
    setSelectedMatter(next);
    setmatterref(next?.matterId ?? null);
  };

  const filterParameters = useMemo(() => {
    const parameters = {};
    if (matterref !== null) parameters.matterId = matterref;
    if (valueFrom) parameters.fromDate = fromDate;
    if (valueTo) parameters.toDate = toDate;
    parameters.billStatus = BILL_STATUS_TABS[activeTabIndex].statusCode;
    return parameters;
  }, [matterref, valueFrom, fromDate, valueTo, toDate, activeTabIndex]);

  const dataReceived = (incoming) => {
    if (incoming.data) {
      incoming.data = incoming.data.map((item) => ({
        ...item,
      }));
      setLists(incoming);
    }
  };

  const handleRefresh = () => {
    clearSelection();
    setRefresh(!refresh);
  };

  const dataStateChange = (e) => {
    if (
      e.dataState.sort !== undefined &&
      e.dataState.skip !== 0 &&
      dataState.sort !== e.dataState.sort
    ) {
      setDataState({ ...e.dataState, skip: 0 });
    } else if (e.dataState.sort[0] === undefined) {
      setDataState({
        ...e.dataState,
        sort: [{ field: dataState.sort[0].field, dir: "asc" }],
      });
    } else {
      setDataState(e.dataState);
    }
  };

  const postingDoc = async (chitId) => {
    try {
      const { data } = await api.getPostingDocuments(chitId);
      setFileData(data.data);
      setShowDoc(true);
    } catch (error) { }
  };

  const DocumentCounterCell = (e) => (
    <td>
      <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
        {e.dataItem.documentCount > 0 && (
          <Button
            onClick={() => postingDoc(e.dataItem.chitId)}
            className="border-0"
          >
            <AiOutlineFile color="blue" size={20} />
          </Button>
        )}
        <span>
          {!e.dataItem.documentCount || e.dataItem.documentCount === 0
            ? ""
            : e.dataItem.documentCount}
        </span>
      </div>
    </td>
  );

  const handleMatterLedgerOpen = (dataItem) => {
    const matterId = dataItem?.matterId;
    const matterRef = dataItem?.matterRef;
    if (!matterId || !matterRef) return;
    dispatch(changeLedgerLink("MatterLedger", { matterId, matterRef }));
    navigate("/accounts/matterledger");
  };

  const MatterRefCell = (cellProps) => {
    const matterId = cellProps?.dataItem?.matterId;
    const matterRef = cellProps?.dataItem?.matterRef;
    if (!matterId || !matterRef) return <td>{matterRef ?? ""}</td>;
    return (
      <td>
        <span
          style={{ cursor: "pointer" }}
          onClick={() => handleMatterLedgerOpen(cellProps.dataItem)}
        >
          <u>{matterRef}</u>
        </span>
      </td>
    );
  };

  const openRejectDialog = (billRequestId) => {
    setRejectBillId(billRequestId);
    setRejectReason("");
    setShowRejectReasonDialog(true);
  };

  const handleRejectBill = async () => {
    if (!rejectBillId) return;
    if (!rejectReason?.trim()) {
      toast.error("A rejection reason is required.");
      return;
    }
    setIsRejecting(true);
    try {
      await rejectBillingReqeust(rejectBillId, {
        rejectReason: rejectReason.trim(),
      });
      toast.success("Bill Request rejected.");
      setShowRejectReasonDialog(false);
      setRejectReason("");
      setRejectBillId(null);
      handleRefresh();
    } catch (error) {
      toast.error("Could not reject bill request.");
    } finally {
      setIsRejecting(false);
    }
  };

  const handleAuthorise = async () => {
    if (authChecked.length === 0) return;
    setIsAuthorizing(true);
    try {
      const payload = authChecked.map((billRequestId) => ({ billRequestId }));
      await authorizeBills(payload);
      toast.success("Bill(s) authorised.");
      handleRefresh();
    } catch (error) {
      toast.error("Could not authorise bill(s).");
    } finally {
      setIsAuthorizing(false);
    }
  };

  const toggleAuthRow = (billRequestId) => {
    setAuthChecked((prev) => {
      const next = prev.includes(billRequestId)
        ? prev.filter((id) => id !== billRequestId)
        : [...prev, billRequestId];
      const totalRows = list.data?.length || 0;
      setAuthSelectAll(totalRows > 0 && next.length === totalRows);
      return next;
    });
  };

  const handleAuthSelectAll = () => {
    const totalRows = list.data?.length || 0;
    if (authSelectAll || authChecked.length === totalRows) {
      setAuthChecked([]);
      setAuthSelectAll(false);
    } else {
      setAuthChecked((list.data || []).map((r) => r.billRequestId));
      setAuthSelectAll(true);
    }
  };

  const PostButtonCell = (cellProps) => (
    <td className="px-0">
      <Button
        className="common-btn"
        style={{ minWidth: "0", width: "78px", height: "30px", padding: "0 10px" }}
        onClick={() => getBillRequestDetails(cellProps.dataItem)}
        disabled={cellProps.dataItem.status === "Rejected"}
      >
        Review
      </Button>
    </td>
  );

  const AmendButtonCell = (cellProps) => (
    <td className="px-0">
      <Button
        className="common-btn"
        style={{ minWidth: "0", width: "78px", height: "30px", padding: "0 10px" }}
        onClick={() => getBillRequestDetails(cellProps.dataItem)}
      >
        Amend
      </Button>
    </td>
  );

  const RejectButtonCell = (cellProps) => (
    <td className="px-0">
      <Button
        className="common-btn bgBtnSecondary"
        style={{ minWidth: "0", width: "78px", height: "30px", padding: "0 10px" }}
        onClick={() => openRejectDialog(cellProps.dataItem.billRequestId)}
      >
        Reject
      </Button>
    </td>
  );

  const AuthCheckboxCell = (cellProps) => {
    const id = cellProps.dataItem.billRequestId;
    return (
      <td className="text-center align-middle">
        <Checkbox
          checked={authChecked.includes(id)}
          onChange={() => toggleAuthRow(id)}
        />
      </td>
    );
  };

  const AuthCheckboxHeader = () => (
    <th className="text-center align-middle">
      <div className="d-flex align-items-center justify-content-center ps-3 ms-1">
        <Checkbox checked={authSelectAll} onChange={handleAuthSelectAll} />
      </div>
    </th>
  );

  const STATUS_BADGE_CLASS = {
    Rejected: "bg-danger text-white",
    Billed: "bg-success text-white",
    PendingPosting: "bg-warning text-dark",
    PendingAuthorization: "bg-info text-dark",
  };

  const StatusCell = (cellProps) => {
    const { dataItem } = cellProps;
    const { status, rejectReason: rr } = dataItem;
    const isRejected = status === "Rejected";
    const badgeClass = STATUS_BADGE_CLASS[status] || "bg-secondary text-white";
    return (
      <td className="text-center align-middle">
        <Tooltip anchorElement="target" position="auto">
          <span
            className={`badge rounded-pill d-inline-flex justify-content-center align-items-center py-2 px-3 fs-7 ${badgeClass} ${isRejected ? "cursor-pointer" : ""
              }`}
            style={{ fontSize: "11px" }}
            title={isRejected && rr ? rr : ""}
          >
            {status}
          </span>
        </Tooltip>
      </td>
    );
  };

  const DetailsCell = (e) => {
      const details = e.dataItem.details?.trim();
      const notes = e.dataItem.notes?.trim();
      return (
        <td>                
          <div className="d-flex flex-column align-items-start fs-sm">                    
            <div className="d-flex align-items-center">
              <span className="fw-medium">
                {details}
              </span>
            </div>                    
            {notes && (
              <div>
                <strong>Notes:</strong> {notes}
              </div>
           )}
          </div>                
        </td>
      );
    };

  const renderContent = () => (
    <div className="h-100 d-flex flex-column">
      {showDoc && (
        <DocumentViewer data={fileData} onClose={() => setShowDoc(false)} />
      )}

      <div className="row">
        <div className="col-12 d-flex flex-wrap align-items-start justify-content-start">
          <div className="d-flex flex-column me-4 mb-1">
            <Label className="mb-2 filter-font">Matter</Label>
            <MattersCombobox
              value={selectedMatter}
              onChangematter={onChangematter}
              className="dropdown-width"
            />
          </div>
          <div className="me-2 mt-1">
            <div className="nominal-form-to-parent-row">
              <div className="labels-containers">
                <Label editorId={"dp"}>From</Label>
                <div className="label-to">
                  <Label editorId="to">To</Label>
                </div>
              </div>
            </div>
            <div className="nominal-form-to-row">
              <div className="date-form-to-wrapper" style={{ height: "40px" }}>
                <div className="from">
                  <div className="d-flex align-items-center justify-content-center">
                    <Checkbox
                      value={valueFrom}
                      className="ms-2 me-1"
                      onChange={(e) => setValueFrom(e.value)}
                      label={""}
                    />
                    <DatePicker
                      id="from"
                      className="date-picker"
                      value={fromDateSelector || null}
                      onChange={onChangeFromDateSelect}
                      toggleButton={CalenderCustomToggleButton}
                    />
                  </div>
                </div>
                <div className="divider"></div>
                <div className="to">
                  <div className="d-flex align-items-center justify-content-center">
                    <Checkbox
                      value={valueTo}
                      className="ms-2 me-1"
                      onChange={(e) => setValueTo(e.value)}
                      label={""}
                    />
                    <DatePicker
                      id="to"
                      className="date-picker"
                      value={toDateSelector || null}
                      onChange={onChangeToDateSelect}
                      toggleButton={CalenderCustomToggleButton}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 me-auto">
            <Button
              className="common-btn"
              onClick={handleRefresh}
              svgIcon={arrowRotateCwIcon}
            >
              <span className="d-flex align-items-center">
                <span className="d-xl-inline-block d-sm-none ms-1">
                  Refresh
                </span>
              </span>
            </Button>
          </div>
        </div>
      </div>

      <div className="flex-grow-1 overflow-auto row mt-3 pb-2">
        <Grid
          {...dataState}
          data={list}
          onDataStateChange={dataStateChange}
          className="fs-md grid-minwidth-col3-150 h-100 overflow-auto"
          sortable={true}
          pageable={state.pageable}
          pageSize={state.pageSize}
        >
          <GridNoRecords>
            {isLoadingBillingRequests ? (
              <span></span>
            ) : (
              list.data && list.data.length === 0 && "No records available"
            )}
          </GridNoRecords>
          <GridColumn
            field="matterRef"
            title="Matter"
            width="140px"
            cell={MatterRefCell}
          />
          <GridColumn
            field="date"
            title="Date"
            cell={DateFormatCell}
            width="110px"
            className="px-1"
          />
            <GridColumn title="Details" field="details" className="px-1"
                cells={{ data: DetailsCell }}
            />
          <GridColumn title="F/E" field="feeEarnerRef" width="60px" />
          <GridColumn
            title="WIP"
            field="wipNetAmount"
            width="80px"
            cells={{ data: AmountFormatCellEmptyZeroNoPadding }}
            headerClassName="grid-header-center"
          />
          <GridColumn
            title="P/C"
            field="pcNetAmount"
            width="80px"
            cells={{ data: AmountFormatCellEmptyZeroNoPadding }}
            headerClassName="grid-header-center"
          />
          <GridColumn
            title="Disb"
            field="disbNetAmount"
            width="80px"
            cells={{ data: AmountFormatCellEmptyZeroNoPadding }}
            headerClassName="grid-header-center"
          />
          <GridColumn
            title="Exp"
            field="expNetAmount"
            width="80px"
            cells={{ data: AmountFormatCellEmptyZeroNoPadding }}
            headerClassName="grid-header-center"
          />
          <GridColumn
            title="VAT"
            field="vatAmount"
            width="80px"
            cells={{ data: AmountFormatCellEmptyZeroNoPadding }}
            headerClassName="grid-header-center"
          />
          <GridColumn
            field="grossAmount"
            title="Bill Amount"
            cell={AmountFormatCell}
            width="120px"
            headerClassName="grid-header-center"
          />
          <GridColumn
            field="documentCount"
            title="Doc"
            width="80px"
            cell={DocumentCounterCell}
            headerClassName="grid-header-center"
          />
          {isPostedTab && (
            <GridColumn
              field="status"
              title="Status"
              width="120px"
              headerClassName="grid-header-center"
              cell={StatusCell}
            />
          )}
          {isAuthorisationTab && (
            <GridColumn
              title=" "
              width="60px"
              cell={AuthCheckboxCell}
              headerCell={AuthCheckboxHeader}
            />
          )}
          {(isPendingTab || isAuthorisationTab) && (
            <GridColumn title=" " cell={RejectButtonCell} width="85" />
          )}
          {isPendingTab && (
            <GridColumn title=" " cell={PostButtonCell} width="80" />
          )}
          {isRejectedTab && (
            <GridColumn title=" " cell={AmendButtonCell} width="85px" />
          )}
        </Grid>
      </div>

      {isAuthorisationTab && (
        <div className="d-flex justify-content-end mt-3">
          <SubmitButton
            className="common-btn"
            onClick={handleAuthorise}
            disabled
            isLoading={isAuthorizing}
            title="Authorise Bill API not available yet"
          >
            Authorise Bill
          </SubmitButton>
        </div>
      )}

      <HandleGridBody
        dataState={dataState}
        onDataReceived={dataReceived}
        currentComponent={"billingRequests"}
        parameters={filterParameters}
        refresh={refresh}
      />

      {showBillingRequest && (
        <BillPostingModal
          onClose={() => {
            setShowBillingRequest(false);
            setBillingRequestPayload();
          }}
          onPostSuccess={() => {
            setShowBillingRequest(false);
            setBillingRequestPayload();
            setRefresh(!refresh);
          }}
          billingRequestPayload={billingRequestPayload}
        />
      )}

      <BillRequestRejectDialog
        open={showRejectReasonDialog}
        loading={isRejecting}
        rejectReason={rejectReason}
        onReasonChange={(e) => setRejectReason(e.value)}
        onClose={() => {
          if (isRejecting) return;
          setShowRejectReasonDialog(false);
          setRejectReason("");
          setRejectBillId(null);
        }}
        onReject={handleRejectBill}
      />
    </div>
  );

  return (
    <div className="page fluid-container h-100">
      <TabStrip
        className="pagetab mt-2 w-100 h-100 "
        selected={activeTabIndex}
        onSelect={onTabSelect}
        keepTabsMounted={true}
      >
        {BILL_STATUS_TABS.map((tab, idx) => (
          <TabStripTab
            key={tab.key}
            title={
              <PageTabItemTitle
                title={tab.label}
                index={idx}
                selected={activeTabIndex}
              />
            }
            contentClassName="pt-4"
          >
            {activeTabIndex === idx ? renderContent() : null}
          </TabStripTab>
        ))}
      </TabStrip>
    </div>
  );
};

export default BillRequests;
